module.exports = __webpack_public_path__ + "img/thumbnail-dog.ec480b60.jpg";